import { Controller } from '@hotwired/stimulus'
import CameraPhoto, { FACING_MODES, IMAGE_TYPES } from 'jslib-html5-camera-photo'

import { Events, Strings } from '../constants'

import {
    addClass,
    removeClass,
    subscribeEvent,
    target,
    unsubscribeEvent,
    decodeDataUri,
    notifier
} from '../utils'

export default class extends Controller {

    static targets = [
        'dialog',
        'stream',
        'picture',
        'take',
        'cancel',
        'confirm'
    ]

    static values = {
        show: Boolean
    }

    cameraPhoto = null
    currentMode = FACING_MODES.ENVIRONMENT
    callback = null

    dialog = () => target(this, 'dialog')

    stream = () => target(this, 'stream')

    picture = () => target(this, 'picture')

    take = () => target(this, 'take')

    cancel = () => target(this, 'cancel')

    confirm = () => target(this, 'confirm')

    initialize = () => {
    }

    connect = () => {

        this.cameraPhoto = new CameraPhoto(this.stream())
        this.currentMode = FACING_MODES.ENVIRONMENT

        subscribeEvent(Events.SHOW_CAMERA, this.open)
        subscribeEvent(Events.HIDE_CAMERA, this.close)
    }

    disconnect = () => {

        this.cameraPhoto = null
        this.currentMode = FACING_MODES.ENVIRONMENT

        unsubscribeEvent(Events.SHOW_CAMERA, this.open)
        unsubscribeEvent(Events.HIDE_CAMERA, this.close)
    }

    open = ({ detail }) => {

        this.showValue = true

        if (this.showValue) {

            removeClass(this.dialog(), 'is-hidden')
        }

        if (detail && typeof detail === 'function') {

            this.callback = detail

        } else {

            this.callback = null
        }

        this.onStart()
    }

    close = () => {

        this.showValue = false

        if (!this.showValue) {

            addClass(this.dialog(), 'is-hidden')
        }

        this.onStop()
    }

    exception = (error) => {

        this.showValue = false

        if (!this.showValue) {

            addClass(this.dialog(), 'is-hidden')
        }

        const message = error.toString()

        if (message.startsWith('NotAllowedError')) {

            notifier.confirm(Strings.ERROR_NOT_ALLOWED_IN_CAMERA, null, false)

        } else if (message.startsWith('NotFoundError')) {

            notifier.alert(Strings.ERROR_NOT_CAMERAS)

        } else {

            notifier.alert(Strings.ERROR_UNEXPECTED_IN_CAMERA)
        }
    }

    onStart = () => {

        if (! this.cameraPhoto) {

            return
        }

        return this.cameraPhoto.startCamera(this.currentMode, {
            width: { min: 640, max: 1280 },
            height: { min: 480, max: 720 }
        })
            .then(() => {

                removeClass(this.take(), 'is-hidden')

                return true
            })
            .catch((error) => {

                this.exception(error)

                return false
            })
    }

    onStop = () => {

        if (! this.cameraPhoto) {

            return
        }

        return this.cameraPhoto.stopCamera()
            .then(() => {

                addClass(this.take(), 'is-hidden')

                return true
            })
            .catch((error) => {

                this.exception(error)

                return false
            })
    }

    change = () => {

        if (this.currentMode === FACING_MODES.ENVIRONMENT) {

            this.currentMode = FACING_MODES.USER

        } else {

            this.currentMode = FACING_MODES.ENVIRONMENT
        }

        const cameraPhoto = this.cameraPhoto

        this.onStop().then((success) => {

            if (success) {

                this.cameraPhoto = cameraPhoto

                this.onStart()
            }
        })
    }

    taken = () => {

        removeClass(this.picture(), 'is-hidden')

        addClass(this.take(), 'is-hidden')

        removeClass(this.cancel(), 'is-hidden')

        removeClass(this.confirm(), 'is-hidden')

        this.picture().src = this.cameraPhoto.getDataUri({
            imageType: IMAGE_TYPES.JPG,
            imageCompression: 0.60
        })
    }

    cancelled = () => {

        addClass(this.picture(), 'is-hidden')

        addClass(this.cancel(), 'is-hidden')

        addClass(this.confirm(), 'is-hidden')

        removeClass(this.take(), 'is-hidden')

        this.picture().src = ''
    }

    confirmed = () => {

        const uri = this.picture().src

        addClass(this.picture(), 'is-hidden')

        addClass(this.cancel(), 'is-hidden')

        addClass(this.confirm(), 'is-hidden')

        removeClass(this.take(), 'is-hidden')

        this.callback && this.callback(decodeDataUri(uri))

        this.picture().src = ''

        this.close()
    }
}
